<template>
  <div>
    <el-dialog
      v-if="visible"
      :visible="visible"
      show-close
      append-to-body
      width="1000px"
      top="5vh"
      :title="title"
      :close-on-click-modal="false"
      :before-close="() => cancel()"
    >
      <div class="d-flex">
        <div class="side-frame-success"></div>
        <div>
          <span style="font-size: 14px; color: #606266">
            {{ $l('form_label_visitNo') || '拜访单号' }}：
            {{ selectData.visitNo }}
          </span>
          <el-divider direction="vertical"></el-divider>
          <span style="font-size: 14px; color: #606266">
            {{ $l('table_label_schedule_showScheduleInfo') || '行程安排' }}：
            {{ selectData.scheduleStartDate }} {{ ' 至 ' }}
            {{ selectData.scheduleEndDate }}
          </span>
          <el-divider direction="vertical"></el-divider>
          <span style="font-size: 14px; color: #606266">
            {{ $l('form_label_city') || '城市' }}：
            {{ selectData.departureCityName }}
            {{ ' 至 ' }}
            {{ selectData.destinationCityName }}
          </span>
        </div>
      </div>
      <el-tabs type="border-card">
        <el-tab-pane :label="$l('form_label_report_tab_1') || '出差报告'">
          <EditForm
            ref="EditForm"
            :formData="selectData"
            :tripReimbursementCode="tripReimbursementCode"
            :tripReimbursementItemCode="tripReimbursementItemCode"
            :disabled="disabled"
          />
        </el-tab-pane>
        <el-tab-pane :label="$l('form_label_report_tab_2') || '相关文档'">
          <ReportDocTable
            ref="ReportDocTable"
            :tripReimbursementCode="tripReimbursementCode"
            :tripReimbursementItemCode="tripReimbursementItemCode"
            :tripReimbursementReportCode="
              selectData.tripReimbursementReportCode
            "
            :disabled="disabled"
        /></el-tab-pane>
      </el-tabs>
      <span slot="footer">
        <el-button size="small" @click="cancel()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" @click="save()" v-if="!disabled">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import EditForm from './report-form.vue'
import ReportDocTable from '../report-doc-table'
export default {
  mixins: [EditLoading],
  components: { EditForm, ReportDocTable },
  props: {
    title: { type: String, default: '' },
    visible: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    tripReimbursementCode: { type: String, default: '' },
    tripReimbursementItemCode: { type: String, default: '' }
  },
  data() {
    return {
      selectData: {}
    }
  },
  watch: {
    visible: {
      handler() {
        if (this.visible) {
          this.getData()
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getData() {
      if (!this.tripReimbursementCode || !this.tripReimbursementItemCode) return
      this.loading = true
      this.$api
        .userTripReimbursementReportEditDetailApi({
          tripReimbursementCode: this.tripReimbursementCode,
          tripReimbursementItemCode: this.tripReimbursementItemCode
        })
        .then((res) => {
          this.loading = false
          this.selectData = res.body
        })
        .catch(() => {
          this.loading = false
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.openQuestion()
    },
    close() {
      this.$emit('update:visible', false)
    },
    openQuestion() {
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存'
        }
      )
        .then(() => {
          this.save(true)
        })
        .catch((action) => {
          if (action === 'cancel') {
            this.close()
          }
        })
    },
    save(isClose = false) {
      this.loadingOpen()
      this.$api
        .userTripReimbursementReportSaveApi({
          tripReimbursementCode: this.tripReimbursementCode,
          tripReimbursementItemCode: this.tripReimbursementItemCode,
          reportList: [this.selectData]
        })
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success'
          })
          if (isClose) {
            this.close()
          } else {
            this.getData()
          }
        })
        .catch(() => {
          this.loadingClose()
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
</style>
